"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Do not edit directly
 */

const palette = {
  blue: {
    accent: {
      '50': 'hsl(191, 100%, 97%)',
      '100': 'hsl(194, 100%, 92%)',
      '200': 'hsl(196, 100%, 82%)',
      '300': 'hsl(200, 100%, 67%)',
      '400': 'hsl(203, 100%, 59%)',
      '500': 'hsl(206, 100%, 51%)',
      '600': 'hsl(213, 94%, 49%)',
      '700': 'hsl(218, 100%, 42%)',
      '800': 'hsl(221, 100%, 34%)',
      '900': 'hsl(231, 75%, 29%)'
    },
    muted: {
      '50': 'hsl(200, 28%, 96%)',
      '100': 'hsl(201, 28%, 92%)',
      '200': 'hsl(204, 26%, 86%)',
      '300': 'hsl(204, 30%, 76%)',
      '400': 'hsl(205, 29%, 66%)',
      '500': 'hsl(205, 25%, 53%)',
      '600': 'hsl(206, 32%, 39%)',
      '700': 'hsl(206, 48%, 24%)',
      '800': 'hsl(206, 48%, 19%)',
      '900': 'hsl(207, 53%, 12%)'
    },
    regular: {
      '50': 'hsl(202, 100%, 95%)',
      '100': 'hsl(203, 100%, 91%)',
      '200': 'hsl(205, 100%, 81%)',
      '300': 'hsl(207, 91%, 65%)',
      '400': 'hsl(208, 77%, 52%)',
      '500': 'hsl(207, 98%, 40%)',
      '600': 'hsl(208, 100%, 32%)',
      '700': 'hsl(210, 100%, 25%)',
      '800': 'hsl(212, 100%, 17%)',
      '900': 'hsl(214, 100%, 9%)'
    }
  },
  coral: {
    accent: {
      '50': 'hsl(12, 100%, 97%)',
      '100': 'hsl(8, 100%, 93%)',
      '200': 'hsl(6, 100%, 85%)',
      '300': 'hsl(4, 100%, 78%)',
      '400': 'hsl(2, 100%, 69%)',
      '500': 'hsl(0, 100%, 60%)',
      '600': 'hsl(0, 89%, 47%)',
      '700': 'hsl(0, 98%, 38%)',
      '800': 'hsl(358, 99%, 32%)',
      '900': 'hsl(355, 100%, 24%)'
    },
    muted: {
      '50': 'hsl(17, 37%, 96%)',
      '100': 'hsl(18, 41%, 93%)',
      '200': 'hsl(15, 24%, 85%)',
      '300': 'hsl(11, 24%, 74%)',
      '400': 'hsl(9, 20%, 66%)',
      '500': 'hsl(8, 19%, 55%)',
      '600': 'hsl(6, 19%, 41%)',
      '700': 'hsl(4, 23%, 28%)',
      '800': 'hsl(3, 26%, 15%)',
      '900': 'hsl(0, 25%, 3%)'
    },
    regular: {
      '50': 'hsl(16, 100%, 97%)',
      '100': 'hsl(13, 100%, 95%)',
      '200': 'hsl(11, 100%, 86%)',
      '300': 'hsl(9, 100%, 78%)',
      '400': 'hsl(7, 100%, 71%)',
      '500': 'hsl(5, 100%, 62%)',
      '600': 'hsl(3, 70%, 51%)',
      '700': 'hsl(1, 74%, 40%)',
      '800': 'hsl(1, 82%, 30%)',
      '900': 'hsl(1, 84%, 22%)'
    }
  },
  green: {
    regular: {
      '50': 'hsl(136, 82%, 95%)',
      '100': 'hsl(139, 90%, 90%)',
      '200': 'hsl(141, 84%, 81%)',
      '300': 'hsl(143, 78%, 68%)',
      '400': 'hsl(145, 72%, 57%)',
      '500': 'hsl(147, 71%, 49%)',
      '600': 'hsl(149, 74%, 40%)',
      '700': 'hsl(151, 82%, 30%)',
      '800': 'hsl(153, 90%, 20%)',
      '900': 'hsl(156, 94%, 12%)'
    },
    accent: {
      '50': 'hsl(174, 82%, 95%)',
      '100': 'hsl(172, 91%, 89%)',
      '200': 'hsl(166, 94%, 83%)',
      '300': 'hsl(162, 96%, 76%)',
      '400': 'hsl(153, 94%, 65%)',
      '500': 'hsl(149, 94%, 50%)',
      '600': 'hsl(147, 100%, 47%)',
      '700': 'hsl(150, 100%, 43%)',
      '800': 'hsl(154, 100%, 37%)',
      '900': 'hsl(158, 73%, 29%)'
    },
    muted: {
      '50': 'hsl(153, 35%, 95%)',
      '100': 'hsl(153, 35%, 91%)',
      '200': 'hsl(154, 32%, 86%)',
      '300': 'hsl(156, 29%, 78%)',
      '400': 'hsl(156, 25%, 62%)',
      '500': 'hsl(157, 21%, 52%)',
      '600': 'hsl(158, 25%, 41%)',
      '700': 'hsl(160, 29%, 31%)',
      '800': 'hsl(162, 25%, 20%)',
      '900': 'hsl(160, 25%, 14%)'
    }
  },
  orange: {
    regular: {
      '50': 'hsl(37, 100%, 95%)',
      '100': 'hsl(34, 100%, 87%)',
      '200': 'hsl(32, 100%, 79%)',
      '300': 'hsl(30, 100%, 72%)',
      '400': 'hsl(28, 100%, 64%)',
      '500': 'hsl(26, 100%, 55%)',
      '600': 'hsl(24, 89%, 45%)',
      '700': 'hsl(22, 98%, 35%)',
      '800': 'hsl(20, 100%, 27%)',
      '900': 'hsl(18, 100%, 20%)'
    },
    accent: {
      '50': 'hsl(48, 100%, 97%)',
      '100': 'hsl(49, 100%, 91%)',
      '200': 'hsl(49, 100%, 86%)',
      '300': 'hsl(46, 100%, 76%)',
      '400': 'hsl(42, 100%, 66%)',
      '500': 'hsl(36, 100%, 56%)',
      '600': 'hsl(22, 100%, 55%)',
      '700': 'hsl(18, 100%, 46%)',
      '800': 'hsl(13, 100%, 42%)',
      '900': 'hsl(10, 100%, 31%)'
    },
    muted: {
      '50': 'hsl(33, 60%, 95%)',
      '100': 'hsl(30, 42%, 91%)',
      '200': 'hsl(28, 32%, 85%)',
      '300': 'hsl(28, 29%, 72%)',
      '400': 'hsl(27, 25%, 61%)',
      '500': 'hsl(26, 21%, 53%)',
      '600': 'hsl(25, 25%, 44%)',
      '700': 'hsl(24, 29%, 30%)',
      '800': 'hsl(28, 25%, 19%)',
      '900': 'hsl(27, 24%, 15%)'
    }
  },
  purple: {
    regular: {
      '50': 'hsl(264, 100%, 96%)',
      '100': 'hsl(260, 100%, 94%)',
      '200': 'hsl(261, 100%, 91%)',
      '300': 'hsl(258, 92%, 85%)',
      '400': 'hsl(256, 78%, 73%)',
      '500': 'hsl(254, 70%, 62%)',
      '600': 'hsl(252, 48%, 50%)',
      '700': 'hsl(250, 54%, 38%)',
      '800': 'hsl(248, 60%, 27%)',
      '900': 'hsl(245, 61%, 21%)'
    },
    accent: {
      '50': 'hsl(272, 100%, 97%)',
      '100': 'hsl(268, 100%, 94%)',
      '200': 'hsl(267, 100%, 90%)',
      '300': 'hsl(265, 100%, 84%)',
      '400': 'hsl(263, 100%, 75%)',
      '500': 'hsl(261, 95%, 66%)',
      '600': 'hsl(259, 78%, 57%)',
      '700': 'hsl(257, 80%, 45%)',
      '800': 'hsl(255, 85%, 35%)',
      '900': 'hsl(253, 93%, 24%)'
    },
    muted: {
      '50': 'hsl(264, 19%, 97%)',
      '100': 'hsl(264, 38%, 94%)',
      '200': 'hsl(261, 30%, 91%)',
      '300': 'hsl(263, 28%, 85%)',
      '400': 'hsl(258, 25%, 79%)',
      '500': 'hsl(257, 28%, 73%)',
      '600': 'hsl(254, 24%, 62%)',
      '700': 'hsl(253, 18%, 48%)',
      '800': 'hsl(250, 21%, 34%)',
      '900': 'hsl(247, 25%, 21%)'
    }
  },
  red: {
    regular: {
      '50': 'hsl(3, 100%, 96%)',
      '100': 'hsl(5, 100%, 93%)',
      '200': 'hsl(2, 100%, 88%)',
      '300': 'hsl(0, 100%, 79%)',
      '400': 'hsl(358, 100%, 68%)',
      '500': 'hsl(356, 97%, 58%)',
      '600': 'hsl(354, 78%, 47%)',
      '700': 'hsl(352, 87%, 37%)',
      '800': 'hsl(350, 96%, 28%)',
      '900': 'hsl(348, 98%, 20%)'
    },
    accent: {
      '50': 'hsl(343, 100%, 95%)',
      '100': 'hsl(347, 100%, 91%)',
      '200': 'hsl(350, 100%, 85%)',
      '300': 'hsl(350, 100%, 74%)',
      '400': 'hsl(348, 100%, 65%)',
      '500': 'hsl(346, 98%, 53%)',
      '600': 'hsl(344, 96%, 43%)',
      '700': 'hsl(340, 100%, 35%)',
      '800': 'hsl(333, 100%, 27%)',
      '900': 'hsl(324, 100%, 19%)'
    },
    muted: {
      '50': 'hsl(4, 47%, 94%)',
      '100': 'hsl(5, 46%, 91%)',
      '200': 'hsl(0, 38%, 85%)',
      '300': 'hsl(0, 32%, 75%)',
      '400': 'hsl(358, 30%, 67%)',
      '500': 'hsl(356, 23%, 56%)',
      '600': 'hsl(356, 19%, 42%)',
      '700': 'hsl(356, 21%, 28%)',
      '800': 'hsl(349, 21%, 21%)',
      '900': 'hsl(330, 19%, 17%)'
    }
  },
  static: {
    white: 'hsl(0, 0%, 100%)',
    black: 'hsl(0, 0%, 0%)'
  },
  teal: {
    muted: {
      '50': 'hsl(185, 44%, 95%)',
      '100': 'hsl(186, 37%, 90%)',
      '200': 'hsl(187, 31%, 83%)',
      '300': 'hsl(187, 32%, 70%)',
      '400': 'hsl(187, 28%, 59%)',
      '500': 'hsl(189, 24%, 52%)',
      '600': 'hsl(189, 29%, 38%)',
      '700': 'hsl(190, 37%, 25%)',
      '800': 'hsl(191, 44%, 19%)',
      '900': 'hsl(191, 49%, 13%)'
    },
    regular: {
      '50': 'hsl(176, 60%, 95%)',
      '100': 'hsl(177, 61%, 87%)',
      '200': 'hsl(179, 59%, 78%)',
      '300': 'hsl(181, 57%, 58%)',
      '400': 'hsl(183, 60%, 48%)',
      '500': 'hsl(185, 83%, 39%)',
      '600': 'hsl(187, 92%, 30%)',
      '700': 'hsl(189, 100%, 21%)',
      '800': 'hsl(191, 100%, 14%)',
      '900': 'hsl(194, 100%, 10%)'
    },
    accent: {
      '50': 'hsl(183, 92%, 95%)',
      '100': 'hsl(184, 90%, 88%)',
      '200': 'hsl(186, 94%, 81%)',
      '300': 'hsl(186, 92%, 70%)',
      '400': 'hsl(188, 88%, 59%)',
      '500': 'hsl(188, 94%, 46%)',
      '600': 'hsl(190, 100%, 39%)',
      '700': 'hsl(192, 100%, 30%)',
      '800': 'hsl(194, 100%, 23%)',
      '900': 'hsl(196, 100%, 15%)'
    }
  },
  yellow: {
    regular: {
      '50': 'hsl(47, 100%, 93%)',
      '100': 'hsl(48, 100%, 86%)',
      '200': 'hsl(49, 96%, 76%)',
      '300': 'hsl(46, 94%, 69%)',
      '400': 'hsl(46, 98%, 57%)',
      '500': 'hsl(45, 100%, 50%)',
      '600': 'hsl(40, 100%, 43%)',
      '700': 'hsl(37, 100%, 35%)',
      '800': 'hsl(33, 100%, 27%)',
      '900': 'hsl(33, 100%, 20%)'
    },
    accent: {
      '50': 'hsl(66, 86%, 93%)',
      '100': 'hsl(66, 93%, 86%)',
      '200': 'hsl(64, 96%, 77%)',
      '300': 'hsl(62, 97%, 69%)',
      '400': 'hsl(60, 98%, 59%)',
      '500': 'hsl(58, 100%, 50%)',
      '600': 'hsl(58, 100%, 47%)',
      '700': 'hsl(61, 100%, 42%)',
      '800': 'hsl(76, 100%, 36%)',
      '900': 'hsl(94, 100%, 25%)'
    },
    muted: {
      '50': 'hsl(44, 35%, 95%)',
      '100': 'hsl(43, 35%, 90%)',
      '200': 'hsl(42, 32%, 86%)',
      '300': 'hsl(39, 29%, 73%)',
      '400': 'hsl(37, 25%, 62%)',
      '500': 'hsl(35, 21%, 53%)',
      '600': 'hsl(34, 25%, 41%)',
      '700': 'hsl(35, 28%, 30%)',
      '800': 'hsl(37, 26%, 20%)',
      '900': 'hsl(42, 26%, 15%)'
    }
  }
};
var _default = exports.default = palette;